import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';

const OAuthCallback = () => {
  useEffect(() => {
    // Extract session_id from URL hash
    const hash = window.location.hash;
    console.log('OAuth callback received, hash:', hash);
    
    if (hash.includes('session_id=')) {
      const sessionId = hash.split('session_id=')[1].split('&')[0];
      console.log('Session ID:', sessionId);
      
      // Check if this was opened as a popup (has opener)
      if (window.opener && !window.opener.closed) {
        console.log('Popup detected, sending message to parent');
        // Send message to parent window (opener)
        window.opener.postMessage(
          {
            type: 'OAUTH_SUCCESS',
            session_id: sessionId
          },
          window.location.origin
        );
        
        // Close this popup window after a short delay
        setTimeout(() => {
          window.close();
        }, 1000);
      } else {
        // Not a popup or opener was closed, handle callback here
        console.log('No valid opener, handling OAuth callback directly');
        
        // Store session_id in localStorage temporarily
        localStorage.setItem('pending_oauth_session', sessionId);
        
        // Redirect parent window if available, otherwise current window
        if (window.opener && !window.opener.closed) {
          console.log('Redirecting parent window to home');
          window.opener.location.href = '/';
          window.close();
        } else {
          console.log('Redirecting current window to home');
          window.location.href = '/';
        }
      }
    } else {
      // No session_id in hash, something went wrong
      console.error('No session_id found in OAuth callback');
      
      // Try to close or redirect
      if (window.opener && !window.opener.closed) {
        setTimeout(() => {
          window.close();
        }, 2000);
      } else {
        window.location.href = '/';
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin mx-auto mb-4 text-blue-500" />
        <h2 className="text-xl font-semibold text-white mb-2">Completing Login...</h2>
        <p className="text-gray-400">This window will close automatically.</p>
      </div>
    </div>
  );
};

export default OAuthCallback;
